<template>
    <div class="team-container">
        <template v-for="person in personen" v-if="personen">
            <div :class="'person '+getInactiveClass(person)"
                 :style="'background-image:url('+this.config.imageBaseUrl+person.attributes.BildURL+');'"
            />
        </template>
        <template v-else>
            <i v-if="personen===false">
                Leider konnten keine Personen geladen werden. Bitte versuchen Sie es erneut.
            </i>
            <div class="loading-wrapper" v-else>
                <LoadingSpinner class="standort-spinner"/>
                <p>Personen werden geladen...</p>
            </div>
        </template>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/elements/LoadingSpinner.vue";

export default {
    data() {
        return {
            personen: null,
        }
    },
    components: {
        LoadingSpinner
    },
    computed: {
        field() {
            return this.$store.state.clickedField;
        }
    },
    methods: {
        getInactiveClass(person) {
            if (this.$store.state.activePersons === null) {
                return '';
            }
            if (!this.$store.state.activePersons.includes(person.id)) {
                return 'inactive';
            }
        },
        loadAngebote() {
            if (this.field === null) {
                this.clearTimeout = setTimeout(() => {
                    this.personen = null;
                }, 1000);
                return;
            }
            this.apiRequest('/persons?populate[Standorte][populate][Bereich]=*')
                .then(cnt => {
                    if (!cnt) {
                        this.personen = null;
                        return;
                    }
                    this.personen = [];
                    for (const person of cnt.data) {
                        if (!person.attributes.BildURL) {
                            continue;
                        }
                        let standorte = person.attributes.Standorte.data;
                        for (const standort of standorte) {
                            if (standort.attributes.Bereich.data.attributes.Titel === this.field) {
                                this.personen.push(person);
                                break;
                            }
                        }
                    }
                })
                .catch(() => this.personen = false);
        }
    },
    mounted() {
        this.loadAngebote();
    }
}
</script>